import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";
import siteConfig from "../Datas/siteConfig";

const assistanceLinks = [
  { label: "Contact us", to: "/contact" },
  { label: "Shipping", to: "/shipping" },
  { label: "Returns", to: "/returns" },
  { label: "FAQs", to: "/faqs" },
];

const legalLinks = [
  { label: "Policy centre", to: "/policies" },
  { label: "Terms & conditions", to: "/terms" },
  { label: "Privacy policy", to: "/privacy" },
  { label: "Privacy choices", to: "/privacy-choices" },
  { label: "Cookie policy", to: "/cookies" },
  { label: "Accessibility", to: "/accessibility" },
  { label: "Complaints", to: "/complaints" },
  { label: "Legal notice", to: "/legal-notice" },
];

function Footer() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <section
        className="site-footer__brand-panel"
        aria-labelledby="footer-brand-heading"
      >
        <p className="site-footer__eyebrow">Reamflora Hong Kong</p>
        <h2 id="footer-brand-heading">Botanical colour for everyday life.</h2>
        <p className="site-footer__brand-copy">
          Thoughtful hats, easy clothing and small accessories designed with
          practical details and an original botanical point of view.
        </p>
      </section>

      <div className="site-footer__directory">
        <nav
          className="site-footer__column"
          aria-labelledby="footer-assistance"
        >
          <h3 id="footer-assistance">Assistance</h3>
          {assistanceLinks.map((item) => (
            <Link key={item.label} to={item.to} onClick={toTop}>
              {item.label}
            </Link>
          ))}
          <a href={"mailto:" + siteConfig.contact.customerServiceEmail}>
            Customer care
          </a>
        </nav>

        <div className="site-footer__column" aria-labelledby="footer-find-us">
          <h3 id="footer-find-us">Find us</h3>
          <Link to="/contact" onClick={toTop}>
            Gillsville studio
          </Link>
          <a href={`mailto:${siteConfig.contact.customerServiceEmail}`}>
            {siteConfig.contact.customerServiceEmail}
          </a>
          <address>{siteConfig.contact.address}</address>
        </div>

        <nav className="site-footer__column" aria-labelledby="footer-legal">
          <h3 id="footer-legal">Legal</h3>
          {legalLinks.map((item) => (
            <Link key={item.label} to={item.to} onClick={toTop}>
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="site-footer__column" aria-labelledby="footer-payments">
          <h3 id="footer-payments">Payment methods</h3>
          <span aria-label="Supported payment methods">Visa · Mastercard</span>
          <span>American Express · PayPal</span>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="site-footer__locale">
          <label htmlFor="footer-language">Language</label>
          <select id="footer-language" defaultValue="en">
            <option value="en">English</option>
            <option value="zh-HK">繁體中文</option>
          </select>
          <span aria-hidden="true">·</span>
          <span>
            {siteConfig.currency} ({siteConfig.currencySymbol})
          </span>
        </div>
        <Link
          className="site-footer__wordmark"
          to="/"
          aria-label={siteConfig.brandName + " home"}
          onClick={toTop}
        >
          <img src="/head/reamflora-wordmark.svg" alt={siteConfig.brandName} />
        </Link>
        <p>
          © {new Date().getFullYear()} {siteConfig.brandName}. Designed in Hong
          Kong.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
